import apiService from "../../api/api.service";
import {
  CustomerInfoResponse,
  UpdateProfileRequest,
  UpdateNotificationPreferencesRequest,
  UpdateProfileResponse,
} from "./customer.types";
import { ApiResponse } from "../../api/api.types";

export const fetchCustomerInfo = () => {
  return apiService.get<CustomerInfoResponse>("/customers/info");
};

export const updateCustomerProfile = (data: UpdateProfileRequest) => {
  // Check if image is provided to determine if we need FormData
  const hasImage = data.image instanceof File;

  if (hasImage) {
    // Use FormData for image upload
    const formData = new FormData();
    formData.append("firstname", data.firstname);
    formData.append("lastname", data.lastname);
    formData.append("email", data.email);
    formData.append("phone_number", data.phone_number);
    formData.append(
      "is_corporate_campaign_notification",
      String(data.is_corporate_campaign_notification),
    );

    if (data.birth_date) {
      formData.append("birth_date", data.birth_date);
    }

    if (data.gender) {
      formData.append("gender", data.gender);
    }

    if (data.sms_code) {
      formData.append("sms_code", data.sms_code);
    }

    if (data.image) {
      formData.append("image", data.image);
    }

    return apiService.post<ApiResponse<UpdateProfileResponse>>("/customers/info/update-profile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } else {
    // Use JSON for regular update without image
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { image, ...jsonData } = data;
    return apiService.post<ApiResponse<UpdateProfileResponse>, Omit<UpdateProfileRequest, "image">>(
      "/customers/info/update-profile",
      jsonData,
    );
  }
};

export const updateNotificationPreferences = (
  data: UpdateNotificationPreferencesRequest,
) => {
  return apiService.post<
    ApiResponse<null>,
    UpdateNotificationPreferencesRequest
  >("/customers/info/update-notification-preferences", data);
};

export const logoutDevice = (deviceId: number) => {
  return apiService.post<ApiResponse<null>>(
    `/customers/info/logout-device/${deviceId}`,
    undefined,
  );
};
